import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { OrganizationSettingsMembersViewTopBar } from "./TopBar"

export const organizationSettingsMembersViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: OrganizationSettingsMembersViewTopBar,
}
